<script>
  import { PoppyConfetti } from '@/ui/components/animations/PoppyConfetti';

  export default {
    name: 'CheckboxGroup',
    components: {
      PoppyConfetti
    },
    props: {
      options: {
        type: Array,
        required: true,
      },
      value: {
        type: [String, Number, Boolean],
        required: false,
        default: '',
      },
      disabled: {
        type: Boolean,
        required: false,
        default: false,
      },
      showConfetti: {
        type: Boolean,
        required: false,
        default: false,
      },
    },
    methods: {
      optionSelected(key) {
        this.$emit('click', key);
        this.$emit('input', key);
      },
    },
  };
</script>

<template>
  <div class="checkbox-group" :class="disabled ? 'opacity-50' : ''">
    <div
      v-for="(option,index) in options"
      :key="option.key"
      class="checkbox-group__item"
      :class="{
        'checkbox-group__item--selected': option.key == value,
        [option.status ? option.status : 'bg-primary']: option.key == value,
      }"
      @click="disabled ? null : optionSelected(option.key)"
    >
      <PoppyConfetti
        v-if="option.hasConfetti && showConfetti"
        :key="`poppy-confetti-${index}`"
        v-on="$listeners"
      />
      {{ option.value }}
    </div>
  </div>
</template>
